import * as React from "react";
import styled from "styled-components";
import hero from '../../assets/privacy-logo.png';
import hero_mobile from '../../assets/privacy-logo_mobile.png';
import { useGoogleLogin } from '@react-oauth/google';
import axios from "axios";
import Snackbar from '@mui/material/Snackbar';
import { contentImage, buttonIcon } from '../../assets/images';
import apple from '../../assets/brands/1-Apple.png';
import alienware from '../../assets/brands/2-Alienware.jpeg';
import rog from '../../assets/brands/3-ASUS ROG.png';
import predator from '../../assets/brands/4-Acer Predator.png';
import beats from '../../assets/brands/5-Beats.png';
import bose from '../../assets/brands/6-BOSE logo.png';
import gpixel from '../../assets/brands/7-Google Pixel.jpg';
import omen from '../../assets/brands/8-HP OMEN.png';
import ifb from '../../assets/brands/9-IFB Logo.png';
import jbl from '../../assets/brands/10-JBL.jpg';
import legion from '../../assets/brands/11-Lenovo Legion.jpg';
import microsoft from '../../assets/brands/13-Microsoft.jpg';
import motorola from '../../assets/brands/14-motorola.png';
import msi from '../../assets/brands/15-MSI.png';
import nvidia from '../../assets/brands/16-nvidia.png';
import samsung from '../../assets/brands/17-Samsung.png';
import sony from '../../assets/brands/18-sony.png';
import vu from '../../assets/brands/19-Vu.png';
import wanbo from '../../assets/brands/20-wanbo.png';
import nothing from '../../assets/brands/21-nothing.webp';

import { useNavigate } from 'react-router-dom'; // Correct import for navigation hook
import { API_BASE_URL } from '../../config/apiConfig';
const brandsData = [
  { name: "APPLE", image: apple },
  { name: "ALIENWARE", image: alienware },
  { name: "ROG", image: rog },
  { name: "PREDATOR", image: predator },
  { name: "BEATS", image: beats },
  { name: "BOSE", image: bose },
  { name: "G PIXEL", image: gpixel },
  { name: "OMEN", image: omen },
  { name: "IFB", image: ifb },
  { name: "JBL", image: jbl },
  { name: "LEGION", image: legion },
  { name: "MICROSOFT", image: microsoft },
  { name: "MOTOROLA", image: motorola },
  { name: "MSI", image: msi },
  { name: "NVIDIA", image: nvidia },
  { name: "SAMSUNG", image: samsung },
  { name: "SONY", image: sony },
  { name: "VU", image: vu },
  { name: "WANBO", image: wanbo },
  { name: "NOTHING", image: nothing },
];

export function PrivacyPolicy({ defaultSection }) {
  const navigate = useNavigate(); // Correctly placed useNavigate hook inside the component

  const [user, setUser] = React.useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false); // State to handle Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = React.useState(''); // State to store Snackbar message
  const [activeSection, setActiveSection] = React.useState(defaultSection || 'privacy'); // New state to track active section

  // Add form state variables
  const [formData, setFormData] = React.useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    option: '',
    message: ''
  });
  const [formSubmitted, setFormSubmitted] = React.useState(false);

  const handleJoinTheClubClick = useGoogleLogin({
    onSuccess: (codeResponse) => setUser(codeResponse),
    onError: (error) => console.log('Login Failed:', error)
  });
  React.useEffect(
    () => {
      if (user) {
        console.log(user)
        axios
          .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: 'application/json'
            }
          })
          .then((res) => {
            console.log(res)
            login(res.data)
          })
          .catch((err) => console.log(err));
      }
    },
    [user]
  );

  React.useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash) {
        const section = window.location.hash.substring(1);
        if (['faqs', 'privacy', 'terms', 'exchange', 'shipping', 'contact', 'brands'].includes(section)) {
          setActiveSection(section);
        }
      }
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const login = async (user) => {
    console.log('loginapi:', user)
    try {
      const response = await axios.post(`${API_BASE_URL}/user/login`, {
        user: {
          name: user.name,
          email: user.email,
          id: user.id,
          profile_image: user.image
        },
      });
      console.log(response.data)
      if (response.data.is_success) {
        if (response.data.token) {
          axios({
            method: 'post',
            url: `${API_BASE_URL}/user/get-profile`,
            headers: {
              Authorization: response.data.token
            }
          }).then(res => {
            console.log(res.data);
            if (res.data.data[0].gender) {
              sessionStorage.setItem('token', response.data.token);
              navigate('/profile');
            } else {
              sessionStorage.setItem('token', response.data.token);
              navigate('/personalDetails');
            }
          }).catch(error => {
            console.error('Error fetching profile', error);
          });
        }
      } else {
        setSnackbarMessage('Login failed. Please try again.');
        setSnackbarOpen(true);
      }
      return response.data;
    } catch (error) {
      console.error("Error registering user:", error);
      setSnackbarMessage('Login failed. Please try again.');
      setSnackbarOpen(true);
      return null;
    }
  };
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  // Add form handling function
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);

    // Make API call to contact endpoint
    axios.post(`${API_BASE_URL}/user/contact`, formData)
      .then(response => {
        console.log('Contact form submission response:', response.data);
        setSnackbarMessage('Thank you for contacting us! We will get back to you soon.');
        setSnackbarOpen(true);
        // Reset form after successful submission
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          option: '',
          message: ''
        });
        setFormSubmitted(true);
      })
      .catch(error => {
        console.error('Error submitting contact form:', error);
        setSnackbarMessage('There was an error submitting your message. Please try again.');
        setSnackbarOpen(true);
      });
  };

  const renderPrivacyPolicy = () => (
    <>
      <Section>
        <Text>Effective date: 01.11.2025</Text>
      </Section>
      <Section>
        <Description>
          Snehalata Udaykumar Javali ("us", "we", or "our") operates Spoelt via website{" "}
          <strong><Link href="https://www.spoelt.com" target="_blank">
            https://www.spoelt.com
          </Link></strong>{" "}
          (hereinafter referred to as the "Service").
        </Description>
        <Description>
          This page informs you of our policies regarding the collection, use
          and disclosure of personal data when you use our Service and the
          choices you have associated with that data.
        </Description>
        <Description>
          We use your data to provide and improve the Service. By using the
          Service, you agree to the collection and use of information in
          accordance with this policy.
        </Description>
      </Section>
      <Section>
        <SubTitle>Information Collection And Use</SubTitle>
        <Description>
          We collect several different types of information for various
          purposes to provide and improve our Service to you.
        </Description>
      </Section>
      <Section>
        <SubTitle>Types of Data Collected</SubTitle>
        <SubTitle>Personal Data</SubTitle>
        <Description>
          While using our Service, we may ask you to provide us with certain
          personally identifiable information that can be used to contact or
          identify you ("Personal Data"). Personally identifiable information
          may include, but is not limited to:
        </Description>
        <List>
          <ListItem>Email address</ListItem>
          <ListItem>First name and last name</ListItem>
          <ListItem>Phone number</ListItem>
          <ListItem>Address, State, Province, ZIP/Postal code, City</ListItem>
          <ListItem>Date of birth</ListItem>
          <ListItem>PIN code</ListItem>
          <ListItem>Profession (whether student, working professional, startup founder, business owner)</ListItem>
          <ListItem>Institution (whether college, office or organization)</ListItem>
        </List>
        <Description>
          We may use your Personal Data to contact you with newsletters,
          marketing or promotional materials and other information that may
          be of interest to you. You may opt out of receiving any, or all, of
          these communications from us by following the unsubscribe link.
        </Description>
      </Section>
      <Section>
        <SubTitle>Usage Data</SubTitle>
        <Description>
          We may also collect information that your browser sends whenever you
          visit our Service or when you access the Service by or through a
          mobile device ("Usage Data").
        </Description>
        <Description>
          This Usage Data may include information such as your computer's
          Internet Protocol address (e.g. IP address), browser type, browser
          version, the pages of our Service that you visit, the time and date
          of your visit, the time spent on those pages, unique device
          identifiers and other diagnostic data.
        </Description>
        <Description>
          When you access the Service with a mobile device, this Usage Data
          may include information such as the type of mobile device you use,
          your mobile device unique ID, the IP address of your mobile device,
          your mobile operating system, the type of mobile Internet browser
          you use, unique device identifiers and other diagnostic data.
        </Description>
      </Section>
      <Section>
        <SubTitle>Tracking Cookies Data</SubTitle>
        <Description>
          We do not use cookies and similar tracking technologies to track the
          activity on our Service and we do not hold any information about you
          other than that which you provide. A cookie is a small amount of information that's downloaded to your computer or device when you visit our Site. However, we use a number of different cookies, including functional, performance, advertising, and social media or content cookies. Cookies make your browsing experience better by allowing the website to remember your actions and preferences (such as login and region selection). This means you don't have to re-enter this information each time you return to the site or browse from one page to another. Cookies also provide information on how people use the website, for instance whether it's their first time visiting or if they are a frequent visitor. We use the following cookies to optimize your experience on our Site and to provide our services.
        </Description>
      </Section>
      <Section>
        <SubTitle>Use of Data</SubTitle>
        <List>
          <ListItem>To provide and maintain our Service, which is based on user's data provided on the need and greed lists.</ListItem>
          <ListItem>To notify you about changes to our Service</ListItem>
          <ListItem>To allow you to participate in interactive features of our Service when you choose to do so</ListItem>
          <ListItem>To provide customer support</ListItem>
          <ListItem>To gather analysis or valuable information so that we can improve our Service</ListItem>
          <ListItem>To monitor the usage of our Service</ListItem>
          <ListItem>To detect, prevent and address technical issues</ListItem>
          <ListItem>To fulfill your orders and provide information regarding the status of orders</ListItem>
          <ListItem>For internal marketing purposes to provide you with offers and promotions that may interest you</ListItem>
        </List>
      </Section>
      <Section>
        <SubTitle>Retention of Data</SubTitle>
        <Description>
          Spoelt will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.
        </Description>
        <Description>
          Spoelt will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period, except when this data is used to strengthen the security or to improve the functionality of our Service, or we are legally obligated to retain this data for longer time periods.
        </Description>
      </Section>
      <Section>
        <SubTitle>Transfer of Data</SubTitle>
        <Description>
          Your information, including Personal Data, may be transferred to - and maintained on - computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.
        </Description>
        <Description>
          If you are located outside India and choose to provide information to us, please note that we transfer the data, including Personal Data, to India and process it there.
        </Description>
        <Description>
          Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.
        </Description>
        <Description>
          Spoelt will take all the steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organisation or a country unless there are adequate controls in place including the security of your data and other personal information.
        </Description>
      </Section>
      <Section>
        <SubTitle>Disclosure of Data</SubTitle>
        <Description>
          We may disclose personal information that we collect, or you provide:
        </Description>
        <List>
          <ListItem>To our subsidiaries and affiliates.</ListItem>
          <ListItem>To contractors, service providers, and other third parties we use to support our business and who are bound by contractual obligations to keep personal information confidential and use it only for the purposes for which we disclose it to them.</ListItem>
          <ListItem>To fulfill the purpose for which you provide it.</ListItem>
          <ListItem>For any other purpose disclosed by us when you provide the information.</ListItem>
          <ListItem>With your consent.</ListItem>
          <ListItem>To comply with any court order, law, or legal process, including to respond to any government or regulatory request.</ListItem>
          <ListItem>To enforce our rights arising from any contracts entered into between you and us, including for billing and collection.</ListItem>
          <ListItem>If we believe disclosure is necessary or appropriate to protect the rights, property, or safety of Spoelt, our customers, or others.</ListItem>
        </List>
        <Description>The following information will be shared with third parties for the purpose of order delivery:</Description>
        <List>
          <ListItem>Name</ListItem>
          <ListItem>Shipping Address</ListItem>
          <ListItem>Phone number</ListItem>
          <ListItem>PIN code</ListItem>
        </List>
      </Section>
      <Section>
        <SubTitle>Security of Data</SubTitle>
        <Description>
          The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
        </Description>
      </Section>

      <Section>
        <SubTitle>Your Data Protection Rights Under General Data Protection Regulation (GDPR)</SubTitle>
        <Description>
          If you are a resident of the European Union (EU) and European Economic Area (EEA), you have certain data protection rights, covered by GDPR.
        </Description>
        <Description>
          We aim to take reasonable steps to allow you to correct, amend, delete, or limit the use of your Personal Data.
        </Description>
        <Description>
          If you wish to be informed what Personal Data we hold about you and if you want it to be removed from our systems, please email us at
          <EmailLink href="mailto:spoelt.me+support@gmail.com" target="_blank" > spoelt.me+support@gmail.com </EmailLink>
        </Description>
        <Description>
          In certain circumstances, you have the following data protection rights:
        </Description>
        <List>
          <ListItem>The right to access, update or to delete the information we have on you.</ListItem>
          <ListItem>The right of rectification.</ListItem>
          <ListItem>The right to object.</ListItem>
          <ListItem>The right of restriction.</ListItem>
          <ListItem>The right to data portability.</ListItem>
          <ListItem>The right to withdraw consent.</ListItem>
        </List>
      </Section>
      <Section>
        <SubTitle>Service Providers</SubTitle>
        <Description>
          We may employ third party companies and individuals to facilitate our Service ("Service Providers"), provide Service on our behalf, perform Service-related services or assist us in analyzing how our Service is used.
        </Description>
        <Description>These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.</Description>
      </Section>
      <Section>
        <SubTitle>Analytics</SubTitle>
        <Description>We may use third-party Service Providers to monitor and analyze the use of our Service.</Description>
      </Section>
      <Section>
        <SubTitle>Links to Other Sites</SubTitle>
        <Description>
          Our Service may contain links to other sites that are not operated by us. If you click a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.
        </Description>
        <Description>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</Description>
      </Section>
      <Section>
        <SubTitle>Children's Privacy</SubTitle>
        <Description>
          Our Services are not intended for use by children under the age of 13 ("Child" or "Children").
        </Description>
        <Description>
          We do not knowingly collect personally identifiable information from children under 13. If you become aware that a Child has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from a Child without verification of parental consent, we take steps to remove that information from our servers.
        </Description>
      </Section>
      <Section>
        <SubTitle>Changes to This Privacy Policy</SubTitle>
        <Description>
          We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
        </Description>
        <Description>
          We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update "effective date" at the top of this Privacy Policy.
        </Description>
        <Description>
          You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
        </Description>
      </Section>
      <Section>
        <SubTitle>Contact Us</SubTitle>
        <Description>
          If you have any questions about this Privacy Policy, please contact us by email:
          <EmailLink href="mailto:spoelt.me+support@gmail.com" target="_blank" >
            spoelt.me+support@gmail.com
          </EmailLink>
        </Description>
      </Section>
    </>
  );

  const renderTermsAndConditions = () => (
    <>
      <Section>
        <SubTitle>Terms and Conditions</SubTitle>
        <Description>
          Snehalata Udaykumar Javali ("us", "we", or "our") operates Spoelt via website{" "}
          <strong><Link href="https://www.spoelt.com" target="_blank">
            https://www.spoelt.com
          </Link></strong>{" "}
          (hereinafter referred to as the "Service", the or this "Site").
        </Description>
        <Description>
          The following terms and conditions of use (these "Terms") apply to your use of this Site. Please read them carefully. By accessing or using this Site, you are agreeing to these Terms and concluding a legally binding contract with Spoelt. Do not access or use this Site if you are unwilling or unable to be bound by the Terms.
        </Description>
      </Section>
      <Section>
        <SubTitle>Parties</SubTitle>
        <Description>
          The terms "You","Your" and "User" refer to you, as a user of this Site. The terms "We," "Us," and "Our" refer to Spoelt.
        </Description>
      </Section>
      <Section>
        <SubTitle>Description of Service</SubTitle>
        <Description>
          We provide a subscription service for consumers to create a wish list of products and services categorised as Need list and Greed list. Based on the inputs provided, we aggregate demand and facilitate discounted/bulk purchases from the manufacturers and/or importers/distributors etc and the sale will go through only after the demand volumes qualify for the discounted/bulk prices.
        </Description>
        <Description>
          Order fulfillment after the purchase is through the ecommerce model, provided only for a closed community of registered members, who have paid for the subscription service under the "Save" or "Splurge" user personas.
        </Description>
      </Section>
      <Section>
        <SubTitle>Registration and Fees</SubTitle>
        <Description>
          Users must register and pay a subscription fee of <strong>Rs. 999 + GST annually (woah, that's less than Rs.99/month, GST included)</strong> to use our services and access the deals. Users agree to provide accurate information and keep it updated, for annual subscription renewals, product and service purchases.
        </Description>
      </Section>
      <Section>
        <SubTitle>Order Process</SubTitle>
        <Description>
          Users create wish lists, then can place orders from discounted deals curated as per their lists. All sales are final except exchanges. You agree and understand these terms, hence authorise us to charge your payment method upon order confirmation, when you select 'buy now' (applicable for both "Save" and "Splurge" user personas) and auto annual subscription renewals (applicable for both "Save" and "Splurge" user personas). You can opt out of this service and choose to do the renewals manually, in the subscription section.
        </Description>
      </Section>
      <Section>
        <SubTitle>Sale of Products</SubTitle>
        <Description>
          The sale/purchase are limited to one product per user/member/subscriber who have opted for the student or working professional category. This is to discourage users from buying and reselling products illegally in the open market. Larger quantities are allowed for users/members/subscribers who have opted for startup founders, business owners and institutions who have a valid GSTIN. All users/members/subscribers agree and acknowledge that products (or services) purchased from us are intended for personal and business use only and not for reselling.
        </Description>
        <Description>
          All product sales are final upon delivery. We do not provide returns or refunds as the product/service is curated as per user's list at a special price (no returns or refund in any condition, but for one exception stated below). A product will not be returned replaced under the following circumstances:
        </Description>
        <Description>
          An electrical surge or any damage caused by the user and/or The customer is not happy with the look and feel, functioning of a defect-free product.
        </Description>
        <Description>
          We guarantee that all products and services will match descriptions or images almost exactly. Some reasonable variance may exist.
        </Description>
      </Section>
      <Section>
        <SubTitle>Payments</SubTitle>
        <Description>
          All orders are prepaid, which means users are required to provide upfront payment by UPI, net banking, or debit/credit card. You are responsible for all taxes, duties, and fees. We will try to provide EMI and cashback offers/schemes as facilitated by the banks for specific cards, through our payment gateway.
        </Description>
      </Section>
      <Section>
        <SubTitle>Disclaimer of Warranties</SubTitle>
        <Description>
          We expressly disclaim any warranties or representations in respect of availability of service, quality, suitability, accuracy, reliability, completeness, timeliness, performance, safety, merchantability, fitness for a particular purpose, or legality of the products listed or displayed on the Site.
        </Description>
      </Section>
      <Section>
        <SubTitle>Limitation of Liability</SubTitle>
        <Description>
          Our maximum aggregate liability arising from or relating to the Site is limited to the amounts you paid in the last 30 days. We will not be liable for any consequential, indirect, punitive, special, or incidental damages.
        </Description>
      </Section>
      <Section>
        <SubTitle>Governing Law and Jurisdiction</SubTitle>
        <Description>
          These Terms are governed by the laws of India. You agree to submit to the exclusive jurisdiction of courts at Goa.
        </Description>
      </Section>
      <Section>
        <SubTitle>Modifications</SubTitle>
        <Description>
          We may modify these Terms & Conditions at any time. Your continued use of the Site signifies acceptance of updated Terms & Conditions.
        </Description>
      </Section>
      <Section>
        <SubTitle>Contact Us</SubTitle>
        <Description>
          For any questions or concerns, you can reach us at
          <EmailLink href="mailto:spoelt.me+support@gmail.com" target="_blank" > spoelt.me+support@gmail.com </EmailLink>
          , with the subject line marked 'Query'.
        </Description>
      </Section>
      <Section>
        <SubTitle>Privacy Policy</SubTitle>
        <Description>
          Our privacy policy available on the Site governs how we collect, use and disclose your personal information.
        </Description>
      </Section>
      <Section>
        <SubTitle>Grievances</SubTitle>
        <Description>
          Our Grievance Officer is responsible for addressing any complaints or grievances under applicable laws. To submit a grievance, you can write to          <EmailLink href="mailto:spoelt.me+support@gmail.com" target="_blank" > spoelt.me+support@gmail.com </EmailLink>
          , with the subject line marked Grievances.
        </Description>
      </Section>
      <Section>
        <SubTitle>Effective Date</SubTitle>
        <Description>
          These Terms take effect when you access the Site and are further enforced upon registration. Updated versions will be marked with the revision date.
        </Description>
      </Section>
    </>
  );

  const renderExchangeAndRefundPolicy = () => (
    <>
      <Section>
        <SubTitle>Order Process</SubTitle>
        <Description>
          Users create wish lists, then can place orders from discounted deals curated as per their lists. All sales are final except exchanges. You agree and understand these terms, hence authorise us to charge your payment method upon order confirmation, when you select 'buy now' (applicable for both "Save" and "Splurge" user personas) and auto annual subscription renewals (applicable for both "Save" and "Splurge" user personas). You can opt out of this service and choose to do the renewals manually, in the subscription section.
        </Description>
      </Section>
      <Section>
        <SubTitle>Sale of Products</SubTitle>
        <Description>
          All product sales are final upon delivery. We do not provide returns or refunds as the product/service is curated as per user's list at a special price (no returns or refund in any condition, but for one exception stated below). A product will not be returned replaced under the following circumstances:
        </Description>
        <Description>
          An electrical surge or any damage caused by the user and/or The customer is not happy with the look and feel, functioning of a defect-free product.
        </Description>
        <Description>
          We guarantee that all products and services will match descriptions or images almost exactly. Some reasonable variance may exist.
        </Description>
      </Section>
      <Section>
        <SubTitle>Exchanges</SubTitle>
        <Description>
          You can request an exchange if a product is defective (manufacturing defect), damaged, missing parts, or materially different from the description/order summary. Submit requests within 7 days of delivery by email with the subject line marked 'Exchange' to <EmailLink href="mailto:spoelt.me+support@gmail.com" target="_blank">spoelt.me+support@gmail.com</EmailLink>. Items flagged "To be Exchanged" will be verified before a replacement is shipped within 15 days. The product when returned is in unused conditions in the original boxes and with all paperwork (this includes warranties), parts and accessories. "New and unused" means that there are no scratches, marks, or blemishes on the item and the product must not have been sized or altered in any way. We cannot accept a return of any item with any indication that it has been used. Upon request, User has to provide substantial proof such as videos, pictures etc, including but not limited to unboxing, unsealing of the outer package, product package and seal, to back their claims. Our decision on exchange legitimacy is final.
        </Description>
      </Section>
      <Section>
        <SubTitle>Refund</SubTitle>
        <Description>
          In the likelihood, the product/service is unavailable (due to an Out of stock situation), we will refund the user in the form of fund transfer or Spoelt credits within 15 days of resolution. Our decision on the refund is final.
        </Description>
      </Section>
      <Section>
        <SubTitle>Post Purchase Service</SubTitle>
        <Description>
          For product or service guarantee, warranty, preventive or breakdown servicing and other related services, reach out to the brand's point of contact and/or service points, as suggested in the paperwork provided along with the product/service.
        </Description>
      </Section>
    </>
  );

  const renderShippingPolicy = () => (
    <>
      <Section>
        <SubTitle>Shipping Policy</SubTitle>
        <Description>
          We partner with top logistics companies like BlueDart to ensure efficient delivery of your orders.
        </Description>
      </Section>
      <Section>
        <SubTitle>Order Processing</SubTitle>
        <Description>
          To offer you the best prices, we ship orders in batches. Your order will typically be processed within 1-2 days of confirmation.
        </Description>
      </Section>
      <Section>
        <SubTitle>Delivery Timeframe</SubTitle>
        <Description>
          You can expect your order to arrive within 7 business days or sooner after order confirmation. In case of any delays due to unforeseen circumstances, our customer support team will keep you informed.
        </Description>
      </Section>
      <Section>
        <SubTitle>Order Tracking</SubTitle>
        <Description>
          We provide tracking details so you can monitor your order's progress until it reaches you.
        </Description>
      </Section>
      <Section>
        <SubTitle>Risk and Title Transfer</SubTitle>
        <Description>
          Risk and title of the goods transfer to you once your order is packed and handed over to the shipping partner for transit.
        </Description>
      </Section>
      <Section>
        <SubTitle>Issues with Your Order</SubTitle>
        <Description>
          If your order arrives damaged, defective, or incorrect, we'll promptly address the issue according to our exchange policy. Please contact us immediately if you encounter any problems.
        </Description>
      </Section>
      <Section>
        <SubTitle>Returns and Exchanges</SubTitle>
        <Description>
          For qualifying products, we will arrange a pickup for exchanges. Please refer to our exchange policy for more details.
        </Description>
      </Section>
    </>
  );

  const renderFAQs = () => (
    <>
      <Section>
        <SubTitle>FAQs</SubTitle>
        <Description>
          <SubTitle>What is Spoelt?</SubTitle>
          <Description>
            Spoelt is a members only demand based e-commerce platform which lets its users list out products which they wish to purchase immediately (in a month or so) and/or purchase on an annual basis (upgrade their product every year). By purchasing through Spoelt, members are guaranteed to pay far less for their purchases compared to other retail channels.
          </Description>
        </Description>
      </Section>
      <Section>
        <SubTitle>How is Spoelt different from other e-commerce platforms?</SubTitle>
        <Description>
          Spoelt doesn't just list products on the Dealsboard, it curates them at a discounted price for each of its members, based on their Need and Greed List. Spoelt curates these deals only to its subscribed members.
        </Description>
      </Section>
      <Section>
        <SubTitle>Why is an initial subscription fee charged?</SubTitle>
        <Description>
          The initial subscription fees helps us curate the products as per the members' preferences and allows us to negotiate deals with a substantial discount and provide access to these special prices only to our subscribed members. The subscription fee is returned as an additional discount wholly or partially, during the purchase of products during the sale. The subscription fee is similar to a prepaid coupon which provides access to these limited curated deals.
        </Description>
      </Section>
      <Section>
        <SubTitle>What are the Need and Greed Lists?</SubTitle>
        <Description>
          The Need List is for members to put in their buying preference, for products they intend to purchase immediately or in the near future.
          The Greed List is for products which the members would like to buy after saving for it, as they tend to be expensive.
          Spoelt will curate the products based on both these lists and provide substantial discounts, for every product purchase.
        </Description>
      </Section>
      <Section>
        <SubTitle>What is the Dealsboard?</SubTitle>
        <Description>
          Dealsboard is our unique product listing, which only shows you 15 products or less, always. These products are curated based on the members' Need and Greed List and also clubbed with the top trending deals that the other community members are interested in.
        </Description>
        <Description>
          The Dealsboard will start showing the product listing when the deals are about to go live. We will have the sale of these curated products recurring every 15 days, during the weekends. The deals will go live on Friday Midnight and close on Sunday Midnight.
        </Description>
      </Section>
      <Section>
        <SubTitle>What is the Wall of Elts?</SubTitle>
        <Description>
          The Wall of Elts is our way of recognising the importance of having a community and the initial members, who made this initiative possible by believing in our mission. Hence, we will honour the first 10,000 subscribed members, by having their names forever on our 'Wall of Elts'.
        </Description>
      </Section>
      <Section>
        <SubTitle>What is the 'Welcome to Spoelt' Giveaway campaign?</SubTitle>
        <Description>
          We want to provide the first 10,000 subscribed members an additional benefit for choosing to be part of our community. The 'Welcome to Spoelt' Giveaway is an opportunity for select members to win amazing giveaways, by correctly answering 3 questions about Spoelt. Only those subscribed members who correctly answer the 3 questions, qualify to participate in the giveaway.
        </Description>
      </Section>
    </>
  );

  const renderContactUs = () => (
    <>
      <Section>
        <SubTitle>Contact Us</SubTitle>
        <Description>
          We'd love to hear from you! Fill out the form below and we'll get back to you as soon as possible.
        </Description>
      </Section>
      <Section>
        <ContactForm onSubmit={handleFormSubmit}>
          <FormRow>
            <FormGroup>
              <FormLabel>First Name*</FormLabel>
              <FormInput
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleFormChange}
                required
              />
            </FormGroup>
            <FormGroup>
              <FormLabel>Last Name*</FormLabel>
              <FormInput
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleFormChange}
                required
              />
            </FormGroup>
          </FormRow>
          <FormRow>
            <FormGroup>
              <FormLabel>Email*</FormLabel>
              <FormInput
                type="email"
                name="email"
                value={formData.email}
                onChange={handleFormChange}
                required
              />
            </FormGroup>
            <FormGroup>
              <FormLabel>Phone*</FormLabel>
              <FormInput
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleFormChange}
                required
              />
            </FormGroup>
          </FormRow>
          <FormGroup>
            <FormLabel>Select an Option*</FormLabel>
            <FormSelect
              name="option"
              value={formData.option}
              onChange={handleFormChange}
              required
            >
              <option value="">Please select</option>
              <option value="brand">Brand Partnerships</option>
              <option value="campus">Campus Ambassadors</option>
              <option value="query">Query</option>
            </FormSelect>
          </FormGroup>
          <FormGroup>
            <FormLabel>Message*</FormLabel>
            <FormTextarea
              name="message"
              value={formData.message}
              onChange={handleFormChange}
              rows="5"
              required
            />
          </FormGroup>
          <SubmitButton type="submit">Submit</SubmitButton>
        </ContactForm>
      </Section>
      <Section>
        <SubTitle>Contact Information</SubTitle>
        <ContactInfo>
          <ContactItem>
            <strong>Address:</strong> C3, G10 Chandragupta Apartments, Madel, Margao, Goa 403601
          </ContactItem>
          <ContactItem>
            <strong>Email:</strong> <EmailLink href="mailto:spoelt.me@gmail.com">spoelt.me@gmail.com</EmailLink>
          </ContactItem>
        </ContactInfo>
      </Section>
    </>
  );

  const renderBrands = () => (
    <>
      <GridWrapper>
        <GridContainer>
          {brandsData.map((brand, index) => (
            <BrandCard key={index}>
              <ImageContainer>
                <BrandImage src={brand.image} alt={brand.name} />
              </ImageContainer>
            </BrandCard>
          ))}
        </GridContainer>
      </GridWrapper>

      <DisclaimerSection>
        The Logos shown above are the property of their companies. The use of these Logos does not imply any affiliation with or endorsement by the companies (unless specified). All rights to the Logos are retained by the respective companies, and the use is strictly for illustrative purposes in the context of curation of deals on the products/services offered by Spoelt.
      </DisclaimerSection>
    </>
  );

  return (
    <Container>
      <Content>
        <Section1>
          <SectionImage src={window.innerWidth <= 991 ? hero_mobile : hero} alt="Hero" />
          <Header></Header>
        </Section1>
        <Section>
          <Title>
            <TitleItem
              active={activeSection === 'privacy'}
              onClick={() => { navigate('/privacy#privacy'); setActiveSection('privacy'); }}
            >
              [PRIVACY POLICY]
            </TitleItem>
            <TitleItem
              active={activeSection === 'terms'}
              onClick={() => { navigate('/privacy#terms'); setActiveSection('terms'); }}
            >
              [TERMS & CONDITIONS]
            </TitleItem>
            <TitleItem
              active={activeSection === 'brands'}
              onClick={() => { navigate('/privacy#brands'); setActiveSection('brands'); }}
            >
              [BRANDS]
            </TitleItem>
            <TitleItem
              active={activeSection === 'exchange'}
              onClick={() => { navigate('/privacy#exchange'); setActiveSection('exchange'); }}
            >
              [EXCHANGE & REFUND POLICY]
            </TitleItem>
            <TitleItem
              active={activeSection === 'shipping'}
              onClick={() => { navigate('/privacy#shipping'); setActiveSection('shipping'); }}
            >
              [SHIPPING POLICY]
            </TitleItem>
            <TitleItem
              active={activeSection === 'faqs'}
              onClick={() => { navigate('/privacy#faqs'); setActiveSection('faqs'); }}
            >
              [FAQs]
            </TitleItem>
            <TitleItem
              active={activeSection === 'contact'}
              onClick={() => { navigate('/privacy#contact'); setActiveSection('contact'); }}
            >
              [CONTACT US]
            </TitleItem>
          </Title>
        </Section>
        {activeSection === 'privacy' && renderPrivacyPolicy()}
        {activeSection === 'terms' && renderTermsAndConditions()}
        {activeSection === 'exchange' && renderExchangeAndRefundPolicy()}
        {activeSection === 'shipping' && renderShippingPolicy()}
        {activeSection === 'faqs' && renderFAQs()}
        {activeSection === 'contact' && renderContactUs()}
        {activeSection === 'brands' && renderBrands()}
      </Content>
      <div style={{
        display: "flex",
        width: "100%",
        maxWidth: "100%",
        flexDirection: "column",
        backgroundColor: "#eaebef",
        alignItems: "center",
        color: "#202023",
        fontWeight: 400,
        lineHeight: "130%",
        paddingTop: "50px",
        paddingBottom: "50px",
      }}
      >
        <Image2 loading="lazy" src={contentImage} alt="" />

        <TaglineWrapper>
          <TaglineLeft>[</TaglineLeft>
          <TaglineCenter>WE ARE</TaglineCenter>
          <TaglineRight>]</TaglineRight>
        </TaglineWrapper>

        <Subtitle2>Disrupting e-commerce one purchase at a time</Subtitle2>

        <ButtonWrapper>
          <Button onClick={() => navigate('/')}>
            <span>Home</span>
            <ButtonIcon loading="lazy" src={buttonIcon} alt="" />
          </Button>

          <Button onClick={() => navigate('/about')}>
            <span>About Us</span>
            <ButtonIcon loading="lazy" src={buttonIcon} alt="" />
          </Button>

          <LoginButton onClick={handleJoinTheClubClick}>
            <span>Already in the club? login</span>
            <ButtonIcon loading="lazy" src={buttonIcon} alt="" />
          </LoginButton>
        </ButtonWrapper>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
      />
    </Container>
  );
}
const SectionImage = styled.img`
  width: 100%;
  object-fit: fill;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color:white;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 991px) {
  }
`;

const Section1 = styled.section`
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;
const Section = styled.section`
  margin-top: 24px;
  padding: 0 80px;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 0 20px;
  }
`;

const Header = styled.header`
  align-self: start;
  display: flex;
  gap: 1px;
  font-size: 16px;
  letter-spacing: -0.32px;
  @media (max-width: 991px) {
    margin-left: 3px;
  }
`;

const Title = styled.h1`
  letter-spacing: 0.24px;
  margin: auto 0;
  font: 12px/130% Metrophobic, sans-serif;
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;
  padding-bottom: 10px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  
  &::-webkit-scrollbar {
    display: none;
  }
  
  @media (max-width: 991px) {
    padding-bottom: 15px;
  }
`;

const TitleItem = styled.span`
  cursor: pointer;
  padding: 5px 10px;
  background-color: ${props => props.active ? '#e9fe53' : 'transparent'};
  transition: background-color 0.3s ease;
  flex-shrink: 0;
  display: inline-block;
  white-space: nowrap;
  margin-right: 5px;

  &:hover {
    background-color: #e9fe53;
  }
  
  @media (max-width: 991px) {
    font-size: 11px;
  }
`;

const Content = styled.div`
  letter-spacing: -0.36px;
  font-family: Metrophobic, sans-serif;
  @media (max-width: 991px) {
    margin-right: 2px;
    max-width: 100%;
  }
`;

const Text = styled.span`
  font-family: Inter, sans-serif;
  font-weight: 500;
`;

const Description = styled.p`
  margin: 16px 0;
`;

const SubTitle = styled.h2`
  font-family: Inter, sans-serif;
  font-weight: 700;
  margin: 16px 0;
`;

const Link = styled.a`
  text-decoration: underline;
`;

const EmailLink = styled.a`
  font-family: Inter, sans-serif;
  font-weight: 700;
  text-decoration: underline;
`;

const List = styled.ul`
  margin: 0;
  padding-left: 20px;
  list-style-type: disc;
`;

const ListItem = styled.li``;

const Image2 = styled.img`
  aspect-ratio: 4.17;
  object-fit: auto;
  object-position: center;
  width: 60%;
  margin-top: 20px;
`;

const TaglineWrapper = styled.div`
  align-self: center;
  display: flex;
  margin-top: 22px;
  gap: 1px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.32px;
`;

const TaglineLeft = styled.div`
  font-family: Manrope, sans-serif;
  @media (max-width: 991px) {
    font-size: 16px;
    margin-top: 10px;
  }
`;

const TaglineCenter = styled.div`
  text-align: right;
  font-family: Metrophobic, sans-serif;
  font-weight: 400;
  letter-spacing: 0.32px;
  @media (max-width: 991px) {
    font-size: 14px;
    margin-top: 10px;
  }
`;

const TaglineRight = styled.div`
  font-family: Manrope, sans-serif;
  @media (max-width: 991px) {
    font-size: 16px;
    margin-top: 10px;
  }
`;

const GridWrapper = styled.div`
  padding: 60px 80px 0;
  @media (max-width: 991px) {
    padding: 30px 20px 0;
  }
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  width: 100%;
  border-top: 1.5px solid rgba(32, 32, 35, 0.2);
  border-left: 1.5px solid rgba(32, 32, 35, 0.2);

  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 991px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const BrandCard = styled.div`
  aspect-ratio: 1 / 1;
  border-right: 1.5px solid rgba(32, 32, 35, 0.2);
  border-bottom: 1.5px solid rgba(32, 32, 35, 0.2);
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: background-color 0.2s ease;
  cursor: pointer;
  background-color: #FFFFFF;

  &:hover {
    background-color: #F7F7F5;
  }

  @media (max-width: 991px) {
    padding: 20px;
    aspect-ratio: auto;
    min-height: 140px;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BrandImage = styled.img`
  max-width: 80%;
  max-height: 80%;
  object-fit: contain;
`;


const DisclaimerSection = styled.p`
  padding: 60px 80px;
  font: 400 12px/1.4 Metrophobic, sans-serif;
  color: #828282;
  text-align: center;
  margin: 0;
  background-color: #FFFFFF;
  @media (max-width: 991px) {
    padding: 40px 20px;
  }
`;

const Subtitle2 = styled.div`
  text-align: center;
  letter-spacing: -0.42px;
  align-self: center;
  margin-top: 20px;
  font:  21px Metrophobic, sans-serif;
  @media (max-width: 991px) {
    margin-top: 10px;
    font:  16px Metrophobic, sans-serif;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 24px;
  gap: 5px;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: -0.28px;
  padding: 0 1px;
  
  @media (max-width: 991px) {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
`;

const Button = styled.button`
  justify-content: space-between;
  border-radius: 1px;
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  display: flex;
  gap: 8px;
  padding: 16px 13px;
  font-family: Metrophobic, sans-serif;
  cursor: pointer;
  width:260px;  
  text-transform: uppercase;
  white-space: nowrap;
  @media (max-width: 991px) {
    width: 96%;
  }
`;

const ButtonIcon = styled.img`
  aspect-ratio: 1.22;
  object-fit: auto;
  object-position: center;
  width: 11px;
  fill: #202023;
  stroke-width: 1px;
  stroke: #202023;
  margin: auto 0;
`;

const LoginButton = styled(Button)`
  white-space: nowrap;
  
  @media (max-width: 991px) {
    white-space: initial;
  }
`;

// Add new styled components for the contact form
const ContactForm = styled.form`
  width: 100%;
  margin-top: 20px;
`;

const FormRow = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-bottom: 20px;
`;

const FormLabel = styled.label`
  font-family: Inter, sans-serif;
  font-weight: 500;
  margin-bottom: 8px;
`;

const FormInput = styled.input`
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: Metrophobic, sans-serif;
  font-size: 16px;
`;

const FormSelect = styled.select`
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: Metrophobic, sans-serif;
  font-size: 16px;
  background-color: white;
`;

const FormTextarea = styled.textarea`
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: Metrophobic, sans-serif;
  font-size: 16px;
  resize: vertical;
`;

const SubmitButton = styled.button`
  padding: 16px 24px;
  background-color: #e9fe53;
  border: 1px solid rgba(32, 32, 35, 1);
  border-radius: 4px;
  font-family: Metrophobic, sans-serif;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  text-transform: uppercase;
  
  &:hover {
    background-color: #d5ea3f;
  }
`;

const ContactInfo = styled.div`
  margin-top: 20px;
`;

const ContactItem = styled.p`
  margin: 8px 0;
  font-family: Inter, sans-serif;
`;
